import type { Action, Reducer, State } from '../use_candidate_profile';

export const candidateDetailsReducer: Reducer = (
  state: State,
  action: Action
) => {
  switch (action.type) {
    case 'addCandidateDetails': {
      return {
        ...state,
        candidateDetails: action.payload,
      };
    }
    case 'editDetails': {
      return {
        ...state,
        candidateDetails: {
          ...state.candidateDetails,
          ...action.payload,
        },
      };
    }
    case 'editCandidateName': {
      return {
        ...state,
        candidateName: {
          ...action.payload,
        },
      };
    }
    case 'editTags': {
      const candidateDetails = state.candidateDetails
        ? {
            ...state.candidateDetails,
            details: {
              ...state.candidateDetails.details,
              tags: [...action.payload],
            },
          }
        : null;

      return {
        ...state,
        header: {
          ...state.header,
          tags: [...action.payload],
        },
        candidateDetails,
      };
    }
    case 'setDoNotEmail': {
      return {
        ...state,
        doNotEmail: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
